import FKApi from "@/api/api";
import { VizSensor } from "./api";
import { BookmarkFactory, serializeBookmark, FastTime } from "@/views/viz/viz";

const TWO_DAYS_MS = 2 * 86400000;

export interface ExploreRouterLike {
    resolve: (to: { name: string; query?: Record<string, string> }) => { href: string };
}

export async function openExploreForSensor(
    api: FKApi,
    router: ExploreRouterLike,
    stationId: number,
    vizSensor: VizSensor,
    timeRange: [number, number]
): Promise<void> {
    const newWindow = window.open("about:blank", "_blank");
    if (!newWindow) return;

    try {
        const endTime = timeRange[1];
        const bm = BookmarkFactory.forSensor(stationId, vizSensor, [endTime - TWO_DAYS_MS, endTime], FastTime.FortyEightHours);
        const encoded = serializeBookmark(bm);
        const saved = await api.saveBookmark(encoded);
        const url = router.resolve({
            name: "exploreShortBookmark",
            query: { v: saved.token },
        }).href;
        newWindow.location.href = url;
    } catch (err) {
        console.error("viz: navigate error", err);
        newWindow.close();
    }
}
